var _defs, _path, _path2, _polyline, _polyline2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _rect, _path9, _path10, _path11, _polygon, _path12, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _path13, _path14, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _path15, _path16, _path17, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 126.62,
    y1: 249.13,
    x2: 186.64,
    y2: 192.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#552800"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PP") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.53,285.29l-165.77-98c-5.28-3-9.8-7.83-4.66-11L187.47,80.42c2.5-1.55,6.29-2.56,8.82-1.09l174,101c5.28,3.06,6.22,11.63.94,14.69L213.38,285.13A22,22,0,0,1,191.53,285.29Z",
    fill: "#74bc5c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.39,256.63l8.35-5.65,60.5-50-14.32-6.15c-8.59,2.3-24,9-32,12.65-11.81,5.44-23.77,10.37-35.87,15.13q-10.05,4-20.13,7.88C123,238.06,133.77,247.23,144.39,256.63Z",
    opacity: 0.32,
    fill: "url(#linear-gradient)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "205.67 207.67 193.58 202.33 193.58 110 209.46 104.33",
    fill: "#7f1d18"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "213.24 92.33 213.24 201 205.67 207.67 205.67 103",
    fill: "#aa3529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.49,114.93V74.72s-1.06-7.14,11.64-13.49,54.76-30.95,54.76-30.95,20.63-3.7,31.74,26.45a59.73,59.73,0,0,1,3.7,15.8v31.55l-61.11,33.86Z",
    fill: "#68e1fd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.85,112V74.19s1.32-10.58,12.17-6.88,22.22,18.25,24.6,31.74v34.12l-35.45-20.63",
    fill: "#e98669"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.28,115.61l-23.81,28.83s-10.85,16.67,6.88,26.19,34.39-10.32,34.39-10.32L181.11,137Z",
    fill: "#68e1fd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2,114.93l-23.81,28.83s-10.85,16.67,6.88,26.19,34.39-10.32,34.39-10.32L179,136.36Z",
    fill: "#aa3529"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176,86.31c-4.86-8.93-12.57-16.6-20-19.15C145.17,63.46,143.85,74,143.85,74v38C155.85,102.38,161.62,98.28,176,86.31Z",
    fill: "#cd725f"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.22,
    cy: 89.2,
    rx: 17,
    ry: 13.57,
    transform: "translate(44.48 249.93) rotate(-63.74)",
    fill: "#ffd7cb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5,79.9a5.74,5.74,0,0,1,2.22,4.88,10.43,10.43,0,0,1-1.16,5.06,6.16,6.16,0,0,1-3,3.13,1.37,1.37,0,0,1-1.82-.38,4,4,0,0,1-1.91,2,1.85,1.85,0,0,1-2.21-.43,4.51,4.51,0,0,1-1-3.13,8.05,8.05,0,0,1,.93-4.06A5.08,5.08,0,0,1,223,84.53a1.81,1.81,0,0,1,1.68.08l.12-.63,2-.82-.44,6.08c0,.41,0,.77,0,1.07s.15.49.43.37a3.3,3.3,0,0,0,1.42-1.79,7.26,7.26,0,0,0,.63-3.26,4.27,4.27,0,0,0-1.64-3.68,3.81,3.81,0,0,0-3.8-.15,8.44,8.44,0,0,0-4,3.78,11,11,0,0,0-1.54,5.9,5.87,5.87,0,0,0,1.67,4.36q1.6,1.5,4.42.32a13.18,13.18,0,0,0,4.46-3.37l.74,1.85A15.08,15.08,0,0,1,224,98.4c-2.46,1-4.43.91-5.92-.35s-2.27-3.16-2.33-5.73a13.9,13.9,0,0,1,2.12-7.66,11.73,11.73,0,0,1,5.46-5Q226.37,78.39,228.5,79.9Zm-4.35,10.73a5,5,0,0,0,.48-2.23,1.61,1.61,0,0,0-.46-1.27.89.89,0,0,0-1-.15,2.11,2.11,0,0,0-1,1.17,4.75,4.75,0,0,0-.38,2.08,3,3,0,0,0,.35,1.49.61.61,0,0,0,.81.31,2.56,2.56,0,0,0,1.23-1.4",
    fill: "#aa3529"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 193.58,
    y: 39.8,
    width: 3.44,
    height: 71.42,
    rx: 1.72,
    ry: 1.72,
    fill: "#aa3529"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M197,39.8s23.54-2.38,25.13-2.12S197,63.35,197,63.35",
    fill: "#aa3529"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58,186.33c.66-.22,12.52,7.47,12.52,7.47l22.84-13L81,172.93,56.86,186.77",
    fill: "#e0e4ef"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.29,147.19c.88.22,19.11,15.37,19.11,15.37l14.49-6.37L89.57,140.82Z",
    fill: "#e0e4ef"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "100.77 191.95 118.78 191.95 117.24 210.61 99.01 210.61 100.77 191.95",
    fill: "#e0e4ef"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M147,192.39c1.32,0,29.87,8.13,29.87,8.13l8.35-9.22-30.09-7.91Z",
    fill: "#e0e4ef"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "123.96 223.9 116.71 233.78 147.68 240.81 153.39 230.93 123.96 223.9",
    fill: "#e0e4ef"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "181.06 223.24 174.25 232.91 203.9 241.47 210.55 231.37 181.06 223.24",
    fill: "#e0e4ef"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.9 262.11 202.62 275.07 215.13 268.59 191.63 255.31 178.9 262.11",
    fill: "#e0e4ef"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "280.11 184.37 272.86 194.25 303.82 201.28 309.53 191.4 280.11 184.37",
    fill: "#e0e4ef"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "230.91 162.54 229.81 182.53 247.82 182.53 247.82 162.54 230.91 162.54",
    fill: "#e0e4ef"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "294.71 168.03 314.48 183.85 330.07 177.48 308.87 161.23 294.71 168.03",
    fill: "#e0e4ef"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M227.6,135.49,254.83,141s8.13-9.44,7.47-9.44-27-6.15-27-6.15Z",
    fill: "#e0e4ef"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M255,215.57c.44-.66,23.28,12.74,23.28,12.74l12.52-6.38-23.94-14.26Z",
    fill: "#e0e4ef"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.36 221.05 215.95 232.36 249.11 235.54 251.09 223.9 219.36 221.05",
    fill: "#e0e4ef"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "125.14 91.36 132.3 125.53 181.64 98.19 173.32 66.53 125.14 91.36",
    fill: "#e0e4ef"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "125.14 91.36 153.39 96.03 172.44 66.98 125.14 91.36",
    fill: "#fdc54c"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "136.47 97.45 136.47 127.25 174.54 105.95 174.54 75.51 136.47 97.45",
    fill: "#e0e4ef"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "136.47 97.45 158.51 101.38 174.54 75.51 136.47 97.45",
    fill: "#acc9e2"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "146.57 104.73 146.57 134.52 184.64 113.22 184.64 82.79 146.57 104.73",
    fill: "#c5c9d3"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "146.57 104.73 168.61 108.65 184.64 82.79 146.57 104.73",
    fill: "#e4acc9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M192.13,118a82.11,82.11,0,0,1-.77-21.17c0-1-.08-1.9-.11-2.85l-35.75,20.6v29.79l38.07-21.29V120.5A3.52,3.52,0,0,1,192.13,118Z",
    fill: "#e0e4ef"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M191.26,94l-35.75,20.6,22,3.93,13.79-22.26C191.31,95.53,191.28,94.77,191.26,94Z",
    fill: "#e4acc9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M162.23,70.55S180,81.25,180.61,99.06v34.12l13-10.07s.16-33.5-3.89-43.78-17.25-18.74-17.25-18.74Z",
    fill: "#68e1fd"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "89.57 140.82 92.09 151.69 108.89 156.19 89.57 140.82",
    fill: "#fdc54c"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "70.48 193.79 76.85 182.53 93.32 180.84 70.48 193.79",
    fill: "#fdc54c"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "118.78 191.95 110.94 200.51 117.24 210.61 118.78 191.95",
    fill: "#a0d179"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "155.09 183.38 165.6 191.95 185.18 191.29 155.09 183.38",
    fill: "#fdc54c"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "116.71 233.78 134.4 232.36 147.68 240.81 116.71 233.78",
    fill: "#fdc54c"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "181.06 223.24 191.51 231.46 210.55 231.37 181.06 223.24",
    fill: "#fdc54c"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.9 262.11 197.01 265.19 202.62 275.07 178.9 262.11",
    fill: "#a0d179"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.36 221.05 234.22 229.66 251.09 223.9 219.36 221.05",
    fill: "#fdc54c"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "266.82 207.67 272.86 218.72 290.76 221.93 266.82 207.67",
    fill: "#a0d179"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "280.11 184.37 290.76 191.95 309.53 191.4 280.11 184.37",
    fill: "#fdc54c"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "308.87 161.23 309.53 173.22 330.07 177.48 308.87 161.23",
    fill: "#a0d179"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "230.91 162.54 239.92 171.8 229.81 182.53 230.91 162.54",
    fill: "#fdc54c"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "235.28 125.38 243.96 133.18 262.3 131.53 235.28 125.38",
    fill: "#a0d179"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.33eb054ba18b7c504107e0605861b43a.svg";
export { ForwardRef as ReactComponent };